@if (title) {
<div class="-heading">
  <h4>{{ title }}</h4>
  <span>{{ subtitle }}</span>
</div>
}
<div class="-links">
  @for (dropdownLink of dropdownTo; track dropdownLink) {
  <app-link [to]="'/' + dropdownLink.path">
    <lucide-icon [name]="dropdownLink.icon"></lucide-icon>
    <span>{{ dropdownLink.title }}</span>
  </app-link>
  }
</div>
